// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Link Modal Styling */
.link-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  animation: fadeIn 0.2s ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.link-modal-content {
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  max-width: 500px;
  width: 90%;
  animation: slideUp 0.2s ease-out;
}

@keyframes slideUp {
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.link-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #e0e0e0;
}

.link-modal-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #172b4d;
}

.link-modal-close {
  background: none;
  border: none;
  font-size: 28px;
  color: #6b778c;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s;
}

.link-modal-close:hover {
  background-color: #f4f5f7;
  color: #172b4d;
}

.link-modal-body {
  padding: 24px;
}

.link-modal-field {
  margin-bottom: 20px;
}

.link-modal-field:last-child {
  margin-bottom: 0;
}

.link-modal-field label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #172b4d;
}

.link-modal-field input {
  width: 100%;
  padding: 10px 12px;
  border: 2px solid #dfe1e6;
  border-radius: 4px;
  font-size: 14px;
  color: #172b4d;
  transition: all 0.2s;
  box-sizing: border-box;
}

.link-modal-field input:focus {
  outline: none;
  border-color: #4c9aff;
  box-shadow: 0 0 0 1px #4c9aff;
}

.link-modal-field input::placeholder {
  color: #999;
}

.link-modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px;
  border-top: 1px solid #e0e0e0;
  background-color: #fafbfc;
  border-radius: 0 0 8px 8px;
}

.link-modal-button {
  padding: 10px 20px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
}

.link-modal-button-secondary {
  background-color: transparent;
  color: #6b778c;
  border: 1px solid #dfe1e6;
}

.link-modal-button-secondary:hover {
  background-color: #f4f5f7;
  color: #172b4d;
}

.link-modal-button-primary {
  background-color: #0052cc;
  color: white;
  border: 1px solid #0052cc;
}

.link-modal-button-primary:hover:not(:disabled) {
  background-color: #0065ff;
  border-color: #0065ff;
}

.link-modal-button-primary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/components/LinkModal.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;EAChB,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":["/* Link Modal Styling */\n.link-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10000;\n  animation: fadeIn 0.2s ease-in;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.link-modal-content {\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n  max-width: 500px;\n  width: 90%;\n  animation: slideUp 0.2s ease-out;\n}\n\n@keyframes slideUp {\n  from {\n    transform: translateY(20px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n.link-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.link-modal-header h3 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #172b4d;\n}\n\n.link-modal-close {\n  background: none;\n  border: none;\n  font-size: 28px;\n  color: #6b778c;\n  cursor: pointer;\n  padding: 0;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  transition: all 0.2s;\n}\n\n.link-modal-close:hover {\n  background-color: #f4f5f7;\n  color: #172b4d;\n}\n\n.link-modal-body {\n  padding: 24px;\n}\n\n.link-modal-field {\n  margin-bottom: 20px;\n}\n\n.link-modal-field:last-child {\n  margin-bottom: 0;\n}\n\n.link-modal-field label {\n  display: block;\n  margin-bottom: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #172b4d;\n}\n\n.link-modal-field input {\n  width: 100%;\n  padding: 10px 12px;\n  border: 2px solid #dfe1e6;\n  border-radius: 4px;\n  font-size: 14px;\n  color: #172b4d;\n  transition: all 0.2s;\n  box-sizing: border-box;\n}\n\n.link-modal-field input:focus {\n  outline: none;\n  border-color: #4c9aff;\n  box-shadow: 0 0 0 1px #4c9aff;\n}\n\n.link-modal-field input::placeholder {\n  color: #999;\n}\n\n.link-modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding: 16px 24px;\n  border-top: 1px solid #e0e0e0;\n  background-color: #fafbfc;\n  border-radius: 0 0 8px 8px;\n}\n\n.link-modal-button {\n  padding: 10px 20px;\n  border-radius: 4px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  border: none;\n}\n\n.link-modal-button-secondary {\n  background-color: transparent;\n  color: #6b778c;\n  border: 1px solid #dfe1e6;\n}\n\n.link-modal-button-secondary:hover {\n  background-color: #f4f5f7;\n  color: #172b4d;\n}\n\n.link-modal-button-primary {\n  background-color: #0052cc;\n  color: white;\n  border: 1px solid #0052cc;\n}\n\n.link-modal-button-primary:hover:not(:disabled) {\n  background-color: #0065ff;\n  border-color: #0065ff;\n}\n\n.link-modal-button-primary:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
